export const normalizeAssignmentDate = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    const datePart = value.split("T")[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return "";

  return parsedDate.toISOString().split("T")[0];
};

export const mapAssignmentToSelectedValue = (assignment) => ({
  ...assignment,
  qualityAttributeValue: assignment.qualityAttributeValue || assignment.value || "",
  startDate: normalizeAssignmentDate(assignment.startDate),
  endDate: normalizeAssignmentDate(assignment.endDate) || null,
});

const mapByQualityAttributeValueId = (values) =>
  new Map(
    (values || [])
      .filter((value) => value?.qualityAttributeValueId)
      .map((value) => [value.qualityAttributeValueId, value])
  );

export const buildSelectedQualityAttributeValues = ({
  selectedIds,
  availableQualityAttributeValues,
  currentSelectedValues,
  existingAssignmentValues,
  today,
}) => {
  const availableById = mapByQualityAttributeValueId(
    availableQualityAttributeValues
  );
  const currentById = mapByQualityAttributeValueId(currentSelectedValues);
  const existingById = mapByQualityAttributeValueId(existingAssignmentValues);

  return selectedIds.map((qualityAttributeValueId) => {
    const currentValue = currentById.get(qualityAttributeValueId);
    if (currentValue) return currentValue;

    const existingValue = existingById.get(qualityAttributeValueId);
    if (existingValue) return existingValue;

    const availableValue = availableById.get(qualityAttributeValueId);
    return {
      qualityAttributeValueId,
      qualityAttributeValue:
        availableValue?.value || availableValue?.qualityAttributeValue || "",
      startDate: today,
      endDate: null,
    };
  });
};

export const buildOriginalValues = (values) =>
  (values || []).reduce((result, value) => {
    result[value.qualityAttributeValueId] = {
      startDate: value.startDate || "",
      endDate: value.endDate || null,
      noEndDate: false,
    };
    return result;
  }, {});

export const buildNoEndDateFlags = (values, defaultValue = false) =>
  (values || []).reduce((result, value) => {
    result[value.qualityAttributeValueId] = defaultValue;
    return result;
  }, {});
